<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增商品
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词(搜索标题，详情等)"
            />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="queryForm.balance" placeholder="库存状态" clearable class="mr-10">
              <el-option label="售罄" :value="1"> </el-option>
              <el-option label="正常" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="queryForm.step" placeholder="上架状态" clearable>
              <el-option label="待上架" :value="1"> </el-option>
              <el-option label="已上架" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="封面"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <img :src="row.basic.avatar" :class="{avatar: row.basic.avatarSize == 0, 'big-avatar': row.basic.avatarSize == 1}" />
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="价格"
        prop="basic.price"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="商品标签"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag v-for="(item,index) of row.tags||[]" :key="index">{{item.title}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="推荐首页"
        prop="basic.showAtIndexPage"
        show-overflow-tooltip
        >
        <template #default="{ row }">
          <el-tag v-if="row.basic && row.basic.showAtIndexPage == 1" >是</el-tag>

        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="库存状态"
        prop="step"
        show-overflow-tooltip
        >
        <template #default="{ row }">
          <el-tag v-if="row.basic && row.basic.stock && row.basic.stock.balance <= 0" type="error" >售罄</el-tag>
          <el-tag v-else type="success">正常</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="上架状态"
        prop="step"
        show-overflow-tooltip
        >
        <template #default="{ row }">
          <el-tag v-if="row.step == 1" >待上架</el-tag>
          <el-tag v-if="row.step == 2" type="success">已上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleShow(row)">详情</el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="{ cmd: 'edit', item: row }">
                  修改
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'shelf', item: row }">
                  {{ row.step === 1 ? '上架' : '下架' }}
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
    <detail ref="show" />
  </div>
</template>

<script>
import moment from 'moment'
import { findProductList, updateProduct, removeProduct } from '@/api/shop'
import Edit from './edit.vue'
import Detail from './detail.vue'
export default {
  name: 'Shop',
  components: { Edit ,Detail},
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        balance: '',
        step: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/shop/product') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleCommand(command) {
      switch(command.cmd) {
        case 'edit': this.handleEdit(command.item); break;
        case 'delete': this.handleDelete(command.item); break;
        case 'shelf': this.handleShelf(command.item); break;
      }
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleShow(row){
      this.$refs['show'].show(row)
    },
    handleDelete(row) {
      this.$baseConfirm(`你确定要删除商品：${row.title} 吗`, null, async () => {
        await removeProduct({ productId: row.productId })
        this.$baseMessage(
          `删除商品成功`,
          'success',
          false,
          'vab-hey-message-success'
        )
        this.queryData()
      })
    },
    handleShelf(row) {
      updateProduct({
        productId: row.productId,
        step: row.step === 1 ? 2 : 1,
      }).then(res => {
        if (res) {
          this.$message.success(`${row.step === 1 ? '上架' : '下架'}成功`)
          this.fetchData()
        }
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findProductList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
